






import { Vue, Component } from 'vue-property-decorator'
import { protocol } from './data/data'
@Component
export default class YKDPrivacyProtocol extends Vue {
  private protocolData: any = ''
  created() {
    this.protocolData = protocol
  }
}
